module.exports = __webpack_public_path__ + "static/media/Stars-BG.16a32105.jpg";